<template>
  <div class="keyword-search">
    <div class="wrap">
      <div class="page-container">
        <div class="block-title"><h1>Got lost? Let me help you.</h1></div>

        <div class="search-form mew-custom-form__search">
          <div class="search-input-block">
            <input
              type="text"
              name=""
              placeholder="Search the keyword here..."
            />
          </div>
        </div>

        <div class="searchable-contents">
          <p>
            Top Searches: MEWconnect / Swap / Send XSM / Security/ Blockchain /
            Create a Wallet
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import 'KeywordSearch.scss';
</style>
